/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './SettingInfoView.scss'
import React from 'react'
import r from '../../../util/Renderer'
import { NavigationTabs, RadioGroup, RadioInput, TextInput } from '../../atoms'
import RoomAction from '../../../action/room'
import SettingTab from '../../organisms/room/SettingTab'
import { NavigationDrawer, NormalButton, OutlinedButton } from 'ui-library/dist/external/components'

function SettingInfoView(props) {
  const id = props.match.params.id
  const isNew = !Number.isInteger(Number(id))
  const room = props.room
  const headerName = room ? room.name : '新規作成'
  const tabs = SettingTab.getTabMenus(id)

  const name = room.name || ''
  const address = room.address || ''
  const default_check_in = room.default_check_in || ''
  const default_check_out = room.default_check_out || ''
  const system_error_email = room.system_error_email || ''
  const beds24_api_key = room.beds24_api_key || ''
  const beds24_prop_key = room.beds24_prop_key || ''
  const beds24_roomid = room.beds24_roomid || ''
  const neppan_base_url = room.neppan_base_url || ''
  const neppan_userid = room.neppan_userid || ''
  const neppan_password = room.neppan_password || ''
  const neppan_room_type_code = room.neppan_room_type_code || ''
  const key_code = room.key_code || ''
  const room_group_code = room.room_group_code || ''
  const onEdit = e => RoomAction.onEdit(room, e)
  const toolbar = { label: `部屋の設定 [${headerName}]`, items: props.accountMenu }
  const channelManager = props.settingInfo.channelManager

  return (
    <div>
      <NavigationDrawer toolbar={toolbar} navigations={props.navigations} />
      <div className="SettingInfo__NavigationTabs">
        <NavigationTabs tabs={tabs}>
          <div className="col-12 col-md-10 col-lg-6 col-xl-5">
            <h3 className="title">基本情報</h3>
            <div className="settingInfoForm">
              <div className="basicInfo clearfix">
                <div className="row">
                  <div className="col">
                    <TextInput className="formInput1" value={name} type="text" name="name" label={'部屋名'} option="required" onChange={onEdit} />
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <TextInput className="formInput1" value={address} type="text" name="address" label={'住所'} option="required" onChange={onEdit} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <TextInput
                      className="formInput2"
                      value={default_check_in}
                      type="text"
                      name="default_check_in"
                      label={'チェックイン時間'}
                      option="required"
                      placeholder={'14:00'}
                      onChange={onEdit}
                    />
                  </div>
                  <div className="col-6">
                    <TextInput
                      className="formInput2"
                      value={default_check_out}
                      type="text"
                      name="default_check_out"
                      label={'チェックアウト時間'}
                      option="required"
                      placeholder={'11:00'}
                      onChange={onEdit}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <TextInput className="formInput2" value={key_code} type="text" name="key_code" label={'鍵番号'} placeholder={'*1234#'} onChange={onEdit} />
                  </div>
                  <div className="col-6">
                    <TextInput className="formInput2" value={room_group_code} type="text" name="room_group_code" label={'部屋グループコード'} placeholder={''} onChange={onEdit} />
                  </div>
                  {/*<div className="col-6">*/}
                  {/*  <TextInput className="formInput2" value={system_error_email} type="text" name="system_error_email" label={'システムエラーメール'} onChange={onEdit} />*/}
                  {/*</div>*/}
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="col-12 col-md-10 col-lg-6 col-xl-5">
              <h3 className="title">チャネルマネージャー連携</h3>
              <div className="settingInfoForm">
                <div className="beds24InfoForm">
                  <div className="beds24InfoForm__Row">
                    <RadioGroup name="channelManager" value={channelManager}>
                      <RadioInput id="channel-manager-beds24" value="beds24" onChange={e => RoomAction.onEditChannelManager(e.target.value)} />
                      <label htmlFor="channel-manager-beds24">Beds24</label>
                      <RadioInput id="channel-manager-neppan" value="neppan" onChange={e => RoomAction.onEditChannelManager(e.target.value)} />
                      <label htmlFor="channel-manager-neppan">ねっぱん</label>
                      <RadioInput id="channel-manager-none" value="none" onChange={e => RoomAction.onEditChannelManager(e.target.value)} />
                      <label htmlFor="channel-manager-none">連携しない</label>
                    </RadioGroup>
                  </div>
                  {r.renderIf(channelManager === 'beds24')(
                    <div className="bed24FormInput">
                      <div className="row">
                        <div className="col">
                          <TextInput className="formInput" value={beds24_api_key} type="text" name="beds24_api_key" label={'Beds24 APIキー'} option="required" onChange={onEdit} />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <TextInput className="formInput" value={beds24_prop_key} type="text" name="beds24_prop_key" label={'Beds24 Propキー'} option="required" onChange={onEdit} />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <TextInput className="formInput roomId" value={beds24_roomid} type="text" name="beds24_roomid" label={'Beds24 Room ID'} option="required" onChange={onEdit} />
                        </div>
                      </div>
                    </div>
                  )}
                  {r.renderIf(channelManager === 'neppan')(
                    <div className="bed24FormInput">
                      <div className="row">
                        <div className="col">
                          <TextInput className="formInput" value={neppan_base_url} type="text" name="neppan_base_url" label={'ベースURL'} option="required" onChange={onEdit} />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <TextInput className="formInput" value={neppan_userid} type="text" name="neppan_userid" label={'ユーザーID'} option="required" onChange={onEdit} />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <TextInput className="formInput" value={neppan_password} type="text" name="neppan_password" label={'パスワード'} option="required" onChange={onEdit} />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <TextInput className="formInput" value={neppan_room_type_code} type="text" name="neppan_room_type_code" label={'部屋コード'} option="required" onChange={onEdit} />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <p>PMS在庫同期</p>
                          <NormalButton onClick={() => RoomAction.onRequestSyncInventory(room.id)}>PMSの在庫をねっぱんに送信</NormalButton>
                          <p>
                            <font color="red">※ 今日以降の予約がある日しか連動されせん。事前に全ての在庫数を1にしておいてください。</font>
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <FooterAction edited={props.settingInfo.edited} selectedRoom={room} isNew={isNew}>
            {props}
          </FooterAction>
        </NavigationTabs>
      </div>
    </div>
  )
}

function FooterAction(props) {
  const edited = props.edited
  const room = props.selectedRoom
  const isNew = props.isNew
  const channelManager = props.children.settingInfo.channelManager

  return r.renderIfOrElse(isNew)(
    <div className="footButtons col-12 col-md-10 col-lg-6 col-xl-5 mt-4">
      <div className="row">
        <div className="col-auto">
          <OutlinedButton onClick={() => RoomAction.onRequestCreate(room.applyChannelManager(channelManager))}>保存する</OutlinedButton>
        </div>
      </div>
    </div>
  )(
    <div className="footButtons col-12 col-md-10 col-lg-6 col-xl-5 mt-4">
      <div className="row">
        <div className="col-auto">
          <OutlinedButton disabled={!edited} onClick={() => RoomAction.onRequestUpdate(room.applyChannelManager(channelManager))}>
            保存する
          </OutlinedButton>
        </div>
      </div>
    </div>
  )
}

export default SettingInfoView
